export default "__VITE_PUBLIC_ASSET__e28b4391__"